module.exports = __webpack_public_path__ + "static/img/illustratepic_02.65004a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/illustratepic_02.png
// module id = 2MtM
// module chunks = 1